"use client";
const e = Object.freeze({
  primary: "rgb(128, 136, 149)",
  secondary: "rgb(255, 255, 255)"
}), r = Object.keys(e);
export {
  e as DIVIDER_COLORS,
  r as DIVIDER_COLOR_KEYS
};
